/**
 * Celda de mes del calendario de pago (átomo de design-system compartido).
 *
 * Fuente única de verdad del lenguaje visual de los 12 meses de una casa,
 * usado por la grilla anual de Tesorería (`GrillaCasasAnual`) y por el reporte
 * de ficha de vecino de la Comisión (`ConsultaVecinos`). Extraído aquí (antes
 * vivía dentro de GrillaCasasAnual) para no duplicar colores/símbolos entre
 * módulos.
 *
 * - 🟢 verde + ✓ = pagado
 * - 🔴 rojo + ✗ = no pagado
 * - 🟣 morado + C = compensación
 * - ⬜ dashed + · = futuro
 */
import type { EstadoMes } from '../../lib/api/casas-tesoreria';

export const MES_CORTO = [
  'E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D',
];

export const ESTILO_MES: Record<
  EstadoMes,
  { bg: string; text: string; symbol: string; label: string }
> = {
  pagado: {
    bg: '#1f5e36',
    text: '#5fd9b1',
    symbol: '✓',
    label: 'Pagado',
  },
  no_pagado: {
    bg: '#5e1f1f',
    text: '#ff7a7a',
    symbol: '✗',
    label: 'No pagado',
  },
  compensacion: {
    bg: '#3d2a5e',
    text: '#b89bff',
    symbol: 'C',
    label: 'Compensación',
  },
  futuro: {
    bg: 'transparent',
    text: '#5a554d',
    symbol: '·',
    label: 'Futuro',
  },
};

export function CeldaMes({
  estado,
  small,
}: {
  estado: EstadoMes;
  small?: boolean;
}) {
  const s = ESTILO_MES[estado];
  const size = small ? 14 : 18;
  return (
    <div
      className="flex items-center justify-center rounded-sm text-[10px] font-medium"
      style={{
        width: size,
        height: size,
        backgroundColor: s.bg,
        color: s.text,
        border: estado === 'futuro' ? '1px dashed #26262a' : 'none',
      }}
      title={s.label}
    >
      {s.symbol}
    </div>
  );
}
